<script>
import { SeasonPageElementMixin } from "%/dynamic-component-editor/standard-pages/season-page/season-page-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";
import { CountElementMixin }
  from "%/dynamic-component-editor/standard-elements/text-element/count-element-mixin";

export default {
  name: "SeasonName",
  elementPanelSettings: {
    displayName: "Season Name",
    displayIcon: "material-symbols:title",
    elementGroup: "season",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [SeasonPageElementMixin, CountElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      if (this.entity.name) {
        return this.entity.name;
      }
      const seasonNumber = this.entity.seasonNumber;
      if (seasonNumber !== undefined && seasonNumber !== null) {
        return this.formattedCount(seasonNumber);
      }
      return "";
    },
  },
};
</script>

